/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdDocumentsQueryResponse,
  GetApiV1PersonIdDocumentsPathParams,
  GetApiV1PersonIdDocuments401,
  GetApiV1PersonIdDocuments404,
  GetApiV1PersonIdDocuments500,
} from "../../types/personRegisterController/GetApiV1PersonIdDocuments.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdDocuments } from "../../clients/personRegisterController/getApiV1PersonIdDocuments.ts";

export const getApiV1PersonIdDocumentsQueryKey = (
  id: GetApiV1PersonIdDocumentsPathParams["id"],
) => [{ url: "/api/v1/person/:id/documents", params: { id: id } }] as const;

export type GetApiV1PersonIdDocumentsQueryKey = ReturnType<
  typeof getApiV1PersonIdDocumentsQueryKey
>;

export function getApiV1PersonIdDocumentsQueryOptions(
  id: GetApiV1PersonIdDocumentsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdDocumentsQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdDocumentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdDocuments401
      | GetApiV1PersonIdDocuments404
      | GetApiV1PersonIdDocuments500
    >,
    GetApiV1PersonIdDocumentsQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdDocuments(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados de documentos de uma pessoa (CPF, RG, passaporte, CRNM, CIN). **(Requer Authorization para autenticação)**
 * @summary Obter dados de documentos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/documents}
 */
export function useGetApiV1PersonIdDocuments<
  TData = GetApiV1PersonIdDocumentsQueryResponse,
  TQueryData = GetApiV1PersonIdDocumentsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdDocumentsQueryKey,
>(
  id: GetApiV1PersonIdDocumentsPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdDocumentsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdDocuments401
          | GetApiV1PersonIdDocuments404
          | GetApiV1PersonIdDocuments500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdDocumentsQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdDocumentsQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdDocuments401
      | GetApiV1PersonIdDocuments404
      | GetApiV1PersonIdDocuments500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
